import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../../services/auth.service";
import {MatLegacyTableDataSource as MatTableDataSource} from "@angular/material/legacy-table";
import {MatLegacyPaginator as MatPaginator} from "@angular/material/legacy-paginator";
import {SmppServerClientFilter} from "./smppServerClient.filter";
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'micro-smppServerClients',
  templateUrl: './smppServerClients.component.html'
})
export class SmppServerClientsComponent implements OnInit, OnDestroy  {

  dataSource:MatTableDataSource<any> = new MatTableDataSource<any>();
  filter:SmppServerClientFilter = new SmppServerClientFilter();
  smppClientServers:any;
  smppStatsTimer:any;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(private auth:AuthService,
              private env:EnvService,
              private http:HttpClient) {
    this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.reload();
    });
  }

  ngOnInit() {
    this.reload();
    this.getClientStats();
    this.smppStatsTimer = setInterval(()=> {
      this.getClientStats();
    }, 15000);

  }

  ngOnDestroy() {
    if (this.smppStatsTimer)
      clearInterval(this.smppStatsTimer);
  }

  reload() {
    let params:HttpParams = this.filter.getParams()
        .set("page", '' + (this.paginator.pageIndex || 0))
        .set("size", '' + (this.paginator.pageSize || 20))
      ;

    this.http.get(`${this.env.e.url}/smppserver/smppServerClients`, {params: params}).subscribe(
      data => {
        let page = data as any;
        this.dataSource.data = page.content;
        this.paginator.pageIndex = page.number;
        this.paginator.pageSize = page.size;
        this.paginator.length = page.totalElements;
//        this.getConnectedClients();
      }
    );
  }

  getClientStats() {
    this.http.get(`${this.env.e.url}/smppserver/smppServers/connected/clients`).subscribe(
      data => {
        this.smppClientServers = data;
      }
    );
  }
}
